/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: n8B0wtVSx4He
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import AppShell from "../../AppShell"; // plasmic-import: Apa7akI9fuQs/component
import TabLayout from "../../TabLayout"; // plasmic-import: 0i0g7bSenwRJ/component
import BottomNav from "../../BottomNav"; // plasmic-import: KUFcRsF9ovEF/component
import ModuleNav from "../../ModuleNav"; // plasmic-import: wOh_p_z-r3kg/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: n-yL9NcVDVDg/component
import LeftSectionNav from "../../LeftSectionNav"; // plasmic-import: LqMwNzsXjkO-/component
import PageLayout from "../../PageLayout"; // plasmic-import: 6gaQHJJIqual/component
import OnboardingContainer from "../../OnboardingContainer"; // plasmic-import: KM-5MN7o_pvE/component
import ButtonPrimary from "../../ButtonPrimary"; // plasmic-import: hEgWOAymJgYc/component
import InputFormShell from "../../InputFormShell"; // plasmic-import: e3sNvwGa9YkJ/component
import FormElement from "../../FormElement"; // plasmic-import: SrXOXPt7amu2/component
import InputField from "../../InputField"; // plasmic-import: Vlgv2YqSKmv3/component
import RadioGroup from "../../RadioGroup"; // plasmic-import: VO3s6GsnNRnj/component
import RadioOption from "../../RadioOption"; // plasmic-import: k7E8qopXsZkS/component
import RadioButtonSeparateComp from "../../RadioButtonSeparateComp"; // plasmic-import: PuL2ys0C7KIA/component
import SignupProgressBar from "../../SignupProgressBar"; // plasmic-import: HGQcTj4KAvT6/component
import StepProgressBar from "../../StepProgressBar"; // plasmic-import: 8wq_5N080X6o/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicWebSignup.module.css"; // plasmic-import: n8B0wtVSx4He/css
import image9YxLRnjN8Oa4 from "./images/image9.svg"; // plasmic-import: YxLRnj_n8OA4/picture
import image183TIq2GJx3VUp from "./images/image18.svg"; // plasmic-import: 3tIq2GJx3vUP/picture

createPlasmicElementProxy;

export const PlasmicWebSignup__VariantProps = new Array("outsideOnboarding");

export const PlasmicWebSignup__ArgProps = new Array();

const $$ = {};

function PlasmicWebSignup__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "outsideOnboarding",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          (() => {
            try {
              return $ctx.query.step;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return undefined;
              }
              throw e;
            }
          })() ?? $props.outsideOnboarding
      },
      {
        path: "step",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "1"
      },
      {
        path: "onboardingContainer.showTerms",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "onboardingContainer.container",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) =>
          hasVariant($state, "outsideOnboarding", "stepThree")
            ? "withText"
            : hasVariant($state, "outsideOnboarding", "stepTwo")
              ? "withForm"
              : hasVariant($state, "outsideOnboarding", "stepOne")
                ? "withForm"
                : undefined
      },
      {
        path: "clickState",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "firstNameStatus",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "normal"
      },
      {
        path: "firstNameInputValue",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "firstNameHelper",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "firstNameHelperShow",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "firstNameCheck",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      },
      {
        path: "lastNameInputValue",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "lastNameStatus",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "normal"
      },
      {
        path: "lastNameHelperShow",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "lastNameHelper",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => ""
      },
      {
        path: "lastNameCheck",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      },
      {
        path: "firstNameValid",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "lastNameValid",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "showTitleCredentials",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "isCheched2",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      },
      {
        path: "isCheckedNo",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "notclicked"
      },
      {
        path: "isCheckedYes",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => "notclicked"
      },
      {
        path: "yesClickCount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      },
      {
        path: "noClickCount",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"pageOnboarding"}
        data-plasmic-override={overrides.pageOnboarding}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.pageOnboarding,
          {
            [sty.pageOnboardingoutsideOnboarding_stepOne]: hasVariant(
              $state,
              "outsideOnboarding",
              "stepOne"
            ),
            [sty.pageOnboardingoutsideOnboarding_stepThree]: hasVariant(
              $state,
              "outsideOnboarding",
              "stepThree"
            ),
            [sty.pageOnboardingoutsideOnboarding_stepTwo]: hasVariant(
              $state,
              "outsideOnboarding",
              "stepTwo"
            )
          }
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <TabLayout
              data-plasmic-name={"tabLayout"}
              data-plasmic-override={overrides.tabLayout}
              className={classNames("__wab_instance", sty.tabLayout)}
              layoutType={"verticalStacked"}
              tabContent={
                <React.Fragment>
                  <PageLayout
                    data-plasmic-name={"pageLayout"}
                    data-plasmic-override={overrides.pageLayout}
                    className={classNames("__wab_instance", sty.pageLayout, {
                      [sty.pageLayoutoutsideOnboarding_stepOne]: hasVariant(
                        $state,
                        "outsideOnboarding",
                        "stepOne"
                      ),
                      [sty.pageLayoutoutsideOnboarding_stepThree]: hasVariant(
                        $state,
                        "outsideOnboarding",
                        "stepThree"
                      ),
                      [sty.pageLayoutoutsideOnboarding_stepTwo]: hasVariant(
                        $state,
                        "outsideOnboarding",
                        "stepTwo"
                      )
                    })}
                    layoutSections={"withoutNav"}
                    pageContent={
                      <OnboardingContainer
                        data-plasmic-name={"onboardingContainer"}
                        data-plasmic-override={overrides.onboardingContainer}
                        buttonsWrapper={
                          <React.Fragment>
                            <ButtonPrimary
                              className={classNames(
                                "__wab_instance",
                                sty.buttonPrimary__giZxo,
                                {
                                  [sty.buttonPrimaryoutsideOnboarding_stepOne__giZxoUL7K]:
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    ),
                                  [sty.buttonPrimaryoutsideOnboarding_stepTwo__giZxoM3MNz]:
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepTwo"
                                    )
                                }
                              )}
                              color={
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepTwo"
                                )
                                  ? "greyTwo"
                                  : hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                    ? "brand"
                                    : "dark"
                              }
                              onClick={async () => {
                                const $steps = {};
                                $steps["goToWebSignup"] = true
                                  ? (() => {
                                      const actionArgs = {
                                        destination: `/replace-me-with-signup?step=${"stepOne"}`
                                      };
                                      return (({ destination }) => {
                                        if (
                                          typeof destination === "string" &&
                                          destination.startsWith("#")
                                        ) {
                                          document
                                            .getElementById(
                                              destination.substr(1)
                                            )
                                            .scrollIntoView({
                                              behavior: "smooth"
                                            });
                                        } else {
                                          location.assign(destination);
                                        }
                                      })?.apply(null, [actionArgs]);
                                    })()
                                  : undefined;
                                if (
                                  $steps["goToWebSignup"] != null &&
                                  typeof $steps["goToWebSignup"] === "object" &&
                                  typeof $steps["goToWebSignup"].then ===
                                    "function"
                                ) {
                                  $steps["goToWebSignup"] =
                                    await $steps["goToWebSignup"];
                                }
                              }}
                            />

                            <ButtonPrimary
                              className={classNames(
                                "__wab_instance",
                                sty.buttonPrimary__jgGPk,
                                {
                                  [sty.buttonPrimaryoutsideOnboarding_stepOne__jgGPkUL7K]:
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    ),
                                  [sty.buttonPrimaryoutsideOnboarding_stepTwo__jgGPkM3MNz]:
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepTwo"
                                    )
                                }
                              )}
                              color={"brand"}
                              onClick={async () => {
                                const $steps = {};
                                $steps["goToSignupStepStepTwo"] =
                                  $ctx.query.step == "stepOne" ||
                                  !$ctx.query.step
                                    ? (() => {
                                        const actionArgs = {
                                          destination: "/signup?step=stepTwo"
                                        };
                                        return (({ destination }) => {
                                          if (
                                            typeof destination === "string" &&
                                            destination.startsWith("#")
                                          ) {
                                            document
                                              .getElementById(
                                                destination.substr(1)
                                              )
                                              .scrollIntoView({
                                                behavior: "smooth"
                                              });
                                          } else {
                                            location.assign(destination);
                                          }
                                        })?.apply(null, [actionArgs]);
                                      })()
                                    : undefined;
                                if (
                                  $steps["goToSignupStepStepTwo"] != null &&
                                  typeof $steps["goToSignupStepStepTwo"] ===
                                    "object" &&
                                  typeof $steps["goToSignupStepStepTwo"]
                                    .then === "function"
                                ) {
                                  $steps["goToSignupStepStepTwo"] =
                                    await $steps["goToSignupStepStepTwo"];
                                }
                                $steps["goToWebSignup"] =
                                  $ctx.query.step == "stepTwo"
                                    ? (() => {
                                        const actionArgs = {
                                          destination: `/replace-me-with-signup?step=${"stepThree"}`
                                        };
                                        return (({ destination }) => {
                                          if (
                                            typeof destination === "string" &&
                                            destination.startsWith("#")
                                          ) {
                                            document
                                              .getElementById(
                                                destination.substr(1)
                                              )
                                              .scrollIntoView({
                                                behavior: "smooth"
                                              });
                                          } else {
                                            location.assign(destination);
                                          }
                                        })?.apply(null, [actionArgs]);
                                      })()
                                    : undefined;
                                if (
                                  $steps["goToWebSignup"] != null &&
                                  typeof $steps["goToWebSignup"] === "object" &&
                                  typeof $steps["goToWebSignup"].then ===
                                    "function"
                                ) {
                                  $steps["goToWebSignup"] =
                                    await $steps["goToWebSignup"];
                                }
                              }}
                            />
                          </React.Fragment>
                        }
                        className={classNames(
                          "__wab_instance",
                          sty.onboardingContainer,
                          {
                            [sty.onboardingContaineroutsideOnboarding_stepOne]:
                              hasVariant(
                                $state,
                                "outsideOnboarding",
                                "stepOne"
                              ),
                            [sty.onboardingContaineroutsideOnboarding_stepThree]:
                              hasVariant(
                                $state,
                                "outsideOnboarding",
                                "stepThree"
                              ),
                            [sty.onboardingContaineroutsideOnboarding_stepTwo]:
                              hasVariant($state, "outsideOnboarding", "stepTwo")
                          }
                        )}
                        container={generateStateValueProp($state, [
                          "onboardingContainer",
                          "container"
                        ])}
                        formWrapper={
                          <React.Fragment>
                            <InputFormShell
                              data-plasmic-name={"formStepTwo"}
                              data-plasmic-override={overrides.formStepTwo}
                              actionsSlot={
                                <React.Fragment>
                                  <ButtonPrimary
                                    className={classNames(
                                      "__wab_instance",
                                      sty.buttonPrimary__bc4U1
                                    )}
                                    color={"greyTwo"}
                                    content={"go back"}
                                    onClick={async () => {
                                      const $steps = {};
                                      $steps["goToWebSignup"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              destination: `/replace-me-with-signup?step=${"stepOne"}`
                                            };
                                            return (({ destination }) => {
                                              if (
                                                typeof destination ===
                                                  "string" &&
                                                destination.startsWith("#")
                                              ) {
                                                document
                                                  .getElementById(
                                                    destination.substr(1)
                                                  )
                                                  .scrollIntoView({
                                                    behavior: "smooth"
                                                  });
                                              } else {
                                                location.assign(destination);
                                              }
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["goToWebSignup"] != null &&
                                        typeof $steps["goToWebSignup"] ===
                                          "object" &&
                                        typeof $steps["goToWebSignup"].then ===
                                          "function"
                                      ) {
                                        $steps["goToWebSignup"] =
                                          await $steps["goToWebSignup"];
                                      }
                                    }}
                                    size={"medium"}
                                    ststus={"normal"}
                                    type={"button"}
                                  />

                                  <ButtonPrimary
                                    className={classNames(
                                      "__wab_instance",
                                      sty.buttonPrimary__hFSon,
                                      {
                                        [sty.buttonPrimaryoutsideOnboarding_stepTwo__hFSonM3MNz]:
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepTwo"
                                          )
                                      }
                                    )}
                                    color={"brand"}
                                    content={"continue"}
                                    onClick={async () => {
                                      const $steps = {};
                                      $steps["goToWebSignup"] = true
                                        ? (() => {
                                            const actionArgs = {
                                              destination: `/replace-me-with-signup?step=${"stepThree"}`
                                            };
                                            return (({ destination }) => {
                                              if (
                                                typeof destination ===
                                                  "string" &&
                                                destination.startsWith("#")
                                              ) {
                                                document
                                                  .getElementById(
                                                    destination.substr(1)
                                                  )
                                                  .scrollIntoView({
                                                    behavior: "smooth"
                                                  });
                                              } else {
                                                location.assign(destination);
                                              }
                                            })?.apply(null, [actionArgs]);
                                          })()
                                        : undefined;
                                      if (
                                        $steps["goToWebSignup"] != null &&
                                        typeof $steps["goToWebSignup"] ===
                                          "object" &&
                                        typeof $steps["goToWebSignup"].then ===
                                          "function"
                                      ) {
                                        $steps["goToWebSignup"] =
                                          await $steps["goToWebSignup"];
                                      }
                                    }}
                                    size={"medium"}
                                    ststus={"normal"}
                                    type={"button"}
                                  />
                                </React.Fragment>
                              }
                              className={classNames(
                                "__wab_instance",
                                sty.formStepTwo,
                                {
                                  [sty.formStepTwooutsideOnboarding_stepTwo]:
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepTwo"
                                    )
                                }
                              )}
                              fieldsSlot={
                                <FormElement
                                  className={classNames(
                                    "__wab_instance",
                                    sty.formElement__cfk6B,
                                    {
                                      [sty.formElementoutsideOnboarding_stepTwo__cfk6BM3MNz]:
                                        hasVariant(
                                          $state,
                                          "outsideOnboarding",
                                          "stepTwo"
                                        )
                                    }
                                  )}
                                  formInputComponent={
                                    <InputField
                                      className={classNames(
                                        "__wab_instance",
                                        sty.inputField__qrd,
                                        {
                                          [sty.inputFieldoutsideOnboarding_stepTwo__qrdm3MNz]:
                                            hasVariant(
                                              $state,
                                              "outsideOnboarding",
                                              "stepTwo"
                                            )
                                        }
                                      )}
                                      placeholder={'"john@email.com"'}
                                      status={"normal"}
                                      type={"email"}
                                    />
                                  }
                                  label={"*email."}
                                  name={"email"}
                                  required={true}
                                  showHelperText={false}
                                />
                              }
                            />

                            <InputFormShell
                              data-plasmic-name={"formStepOne"}
                              data-plasmic-override={overrides.formStepOne}
                              actionsSlot={
                                <ButtonPrimary
                                  className={classNames(
                                    "__wab_instance",
                                    sty.buttonPrimary__smZsj,
                                    {
                                      [sty.buttonPrimaryoutsideOnboarding_stepOne__smZsjUL7K]:
                                        hasVariant(
                                          $state,
                                          "outsideOnboarding",
                                          "stepOne"
                                        )
                                    }
                                  )}
                                  color={
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                      ? "brand"
                                      : undefined
                                  }
                                  content={
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                      ? "continue"
                                      : undefined
                                  }
                                  onClick={async () => {
                                    const $steps = {};
                                    $steps["runCode"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            customFunction: async () => {
                                              return (() => {
                                                console.log(
                                                  "butonul functioneaza"
                                                );
                                                const input2 =
                                                  document.getElementById(
                                                    "firstNameSignUp"
                                                  ).value;
                                                const input1 =
                                                  document.getElementById(
                                                    "lastNameSignUp"
                                                  ).value;
                                                const title =
                                                  document.getElementById(
                                                    "titleId"
                                                  ).value;
                                                const credentials =
                                                  document.getElementById(
                                                    "credentialsId"
                                                  ).value;
                                                console.log(
                                                  "title: ",
                                                  title,
                                                  "credentials: ",
                                                  credentials
                                                );
                                                console.log(
                                                  "Input 2 (firstName):",
                                                  input2
                                                );
                                                console.log(
                                                  "Input 1 (lastName):",
                                                  input1
                                                );
                                                $state.firstNameInputValue =
                                                  input2;
                                                $state.lastNameInputValue =
                                                  input1;
                                                console.log(
                                                  "state of first name input: ",
                                                  $state.firstNameInputValue
                                                );
                                                console.log(
                                                  "state of last name input: ",
                                                  $state.lastNameInputValue
                                                );
                                                console.log(
                                                  "is checked yes: ",
                                                  $state.isCheckedYes
                                                );
                                                console.log(
                                                  "is checked no: ",
                                                  $state.isCheckedNo
                                                );
                                                if (
                                                  $state.isCheckedYes ===
                                                  "clicked"
                                                ) {
                                                  console.log("yes is clicked");
                                                } else if (
                                                  $state.isCheckedNo ===
                                                  "clicked"
                                                ) {
                                                  console.log(
                                                    "no button clicked"
                                                  );
                                                } else if (
                                                  $state.isCheckedYes ===
                                                    "notclicked" &&
                                                  $state.isCheckedNo ===
                                                    "notclicked"
                                                ) {
                                                  console.log(
                                                    "no button is not clciked nor yes button"
                                                  );
                                                }
                                                let firstNameErrors = [];
                                                const firstVal =
                                                  $state.firstNameInputValue;
                                                if (firstVal === "") {
                                                  $state.firstNameStatus =
                                                    "error";
                                                  firstNameErrors.push(
                                                    "First name is empty"
                                                  );
                                                }
                                                if (
                                                  firstNameErrors.length > 0
                                                ) {
                                                  $state.firstNameHelperShow = true;
                                                  $state.firstNameStatus =
                                                    "error";
                                                  $state.firstNameHelper =
                                                    firstNameErrors.join("\n");
                                                  console.log(
                                                    "\u274C First name validation errors:",
                                                    firstNameErrors
                                                  );
                                                } else {
                                                  $state.firstNameHelperShow = false;
                                                  $state.firstNameHelper = "";
                                                  console.log(
                                                    "\u2705 First name passed all checks"
                                                  );
                                                  $state.firstNameValid = true;
                                                }
                                                $state.firstNameCheck =
                                                  firstNameErrors.length === 0;
                                                let lastNameErrors = [];
                                                const lastVal =
                                                  $state.lastNameInputValue;
                                                if (lastVal === "") {
                                                  $state.lastNameStatus =
                                                    "error";
                                                  lastNameErrors.push(
                                                    "Last name is empty"
                                                  );
                                                }
                                                if (lastNameErrors.length > 0) {
                                                  $state.lastNameHelperShow = true;
                                                  $state.lastNameStatus =
                                                    "error";
                                                  $state.lastNameHelper =
                                                    lastNameErrors.join("\n");
                                                  console.log(
                                                    "\u274C Last name validation errors:",
                                                    lastNameErrors
                                                  );
                                                } else {
                                                  $state.lastNameHelperShow = false;
                                                  $state.lastNameHelper = "";
                                                  console.log(
                                                    "\u2705 Last name passed all checks"
                                                  );
                                                  $state.lastNameValid = true;
                                                }
                                                return ($state.lastNameCheck =
                                                  lastNameErrors.length === 0);
                                              })();
                                            }
                                          };
                                          return (({ customFunction }) => {
                                            return customFunction();
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["runCode"] != null &&
                                      typeof $steps["runCode"] === "object" &&
                                      typeof $steps["runCode"].then ===
                                        "function"
                                    ) {
                                      $steps["runCode"] =
                                        await $steps["runCode"];
                                    }
                                    $steps["goToWebSignup"] = (() => {
                                      $state.firstNameInputValue !== "";
                                      return $state.firstNameValid;
                                    })()
                                      ? (() => {
                                          const actionArgs = {
                                            destination: `/replace-me-with-signup?step=${"stepTwo"}`
                                          };
                                          return (({ destination }) => {
                                            if (
                                              typeof destination === "string" &&
                                              destination.startsWith("#")
                                            ) {
                                              document
                                                .getElementById(
                                                  destination.substr(1)
                                                )
                                                .scrollIntoView({
                                                  behavior: "smooth"
                                                });
                                            } else {
                                              location.assign(destination);
                                            }
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["goToWebSignup"] != null &&
                                      typeof $steps["goToWebSignup"] ===
                                        "object" &&
                                      typeof $steps["goToWebSignup"].then ===
                                        "function"
                                    ) {
                                      $steps["goToWebSignup"] =
                                        await $steps["goToWebSignup"];
                                    }
                                  }}
                                  size={
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                      ? "medium"
                                      : undefined
                                  }
                                  ststus={
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                      ? "normal"
                                      : undefined
                                  }
                                  type={"button"}
                                />
                              }
                              className={classNames(
                                "__wab_instance",
                                sty.formStepOne,
                                {
                                  [sty.formStepOneoutsideOnboarding_stepOne]:
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    ),
                                  [sty.formStepOneoutsideOnboarding_stepTwo]:
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepTwo"
                                    )
                                }
                              )}
                              fieldsSlot={
                                <React.Fragment>
                                  <FormElement
                                    className={classNames(
                                      "__wab_instance",
                                      sty.formElement__pbKrw,
                                      {
                                        [sty.formElementoutsideOnboarding_stepOne__pbKrwUL7K]:
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          ),
                                        [sty.formElementoutsideOnboarding_stepTwo__pbKrwm3MNz]:
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepTwo"
                                          )
                                      }
                                    )}
                                    formInputComponent={
                                      <InputField
                                        className={classNames(
                                          "__wab_instance",
                                          sty.inputField__xrX8,
                                          {
                                            [sty.inputFieldoutsideOnboarding_stepOne__xrX8UL7K]:
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              ),
                                            [sty.inputFieldoutsideOnboarding_stepTwo__xrX8M3MNz]:
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepTwo"
                                              )
                                          }
                                        )}
                                        inputId={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? "firstNameSignUp"
                                            : undefined
                                        }
                                        placeholder={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepTwo"
                                          )
                                            ? '"john@email.com"'
                                            : hasVariant(
                                                  $state,
                                                  "outsideOnboarding",
                                                  "stepOne"
                                                )
                                              ? '"John"'
                                              : "John"
                                        }
                                        status={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? (() => {
                                                try {
                                                  return $state.firstNameStatus;
                                                } catch (e) {
                                                  if (
                                                    e instanceof TypeError ||
                                                    e?.plasmicType ===
                                                      "PlasmicUndefinedDataError"
                                                  ) {
                                                    return "normal";
                                                  }
                                                  throw e;
                                                }
                                              })()
                                            : undefined
                                        }
                                        type={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? "text"
                                            : undefined
                                        }
                                        valueInput={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? (() => {
                                                try {
                                                  return $state.firstNameInputValue;
                                                } catch (e) {
                                                  if (
                                                    e instanceof TypeError ||
                                                    e?.plasmicType ===
                                                      "PlasmicUndefinedDataError"
                                                  ) {
                                                    return undefined;
                                                  }
                                                  throw e;
                                                }
                                              })()
                                            : undefined
                                        }
                                      />
                                    }
                                    helperText={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? (() => {
                                            try {
                                              return $state.firstNameHelper;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return undefined;
                                              }
                                              throw e;
                                            }
                                          })()
                                        : undefined
                                    }
                                    label={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? "*first name"
                                        : undefined
                                    }
                                    name={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? "firstName"
                                        : undefined
                                    }
                                    required={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? true
                                        : undefined
                                    }
                                    showHelperText={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? (() => {
                                            try {
                                              return $state.firstNameHelperShow;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return true;
                                              }
                                              throw e;
                                            }
                                          })()
                                        : false
                                    }
                                    status={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? "error"
                                        : "normal"
                                    }
                                  />

                                  <FormElement
                                    className={classNames(
                                      "__wab_instance",
                                      sty.formElement__hplVx,
                                      {
                                        [sty.formElementoutsideOnboarding_stepOne__hplVxUL7K]:
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          ),
                                        [sty.formElementoutsideOnboarding_stepTwo__hplVxm3MNz]:
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepTwo"
                                          )
                                      }
                                    )}
                                    formInputComponent={
                                      <InputField
                                        className={classNames(
                                          "__wab_instance",
                                          sty.inputField___0HY5M,
                                          {
                                            [sty.inputFieldoutsideOnboarding_stepOne___0HY5MUL7K]:
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                          }
                                        )}
                                        inputId={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? "lastNameSignUp"
                                            : undefined
                                        }
                                        placeholder={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? '"Smith"'
                                            : "Doe"
                                        }
                                        status={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? (() => {
                                                try {
                                                  return $state.lastNameStatus;
                                                } catch (e) {
                                                  if (
                                                    e instanceof TypeError ||
                                                    e?.plasmicType ===
                                                      "PlasmicUndefinedDataError"
                                                  ) {
                                                    return "normal";
                                                  }
                                                  throw e;
                                                }
                                              })()
                                            : undefined
                                        }
                                        type={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? "text"
                                            : undefined
                                        }
                                        valueInput={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? (() => {
                                                try {
                                                  return $state.lastNameInputValue;
                                                } catch (e) {
                                                  if (
                                                    e instanceof TypeError ||
                                                    e?.plasmicType ===
                                                      "PlasmicUndefinedDataError"
                                                  ) {
                                                    return undefined;
                                                  }
                                                  throw e;
                                                }
                                              })()
                                            : undefined
                                        }
                                      />
                                    }
                                    helperText={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? (() => {
                                            try {
                                              return $state.lastNameHelper;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return undefined;
                                              }
                                              throw e;
                                            }
                                          })()
                                        : undefined
                                    }
                                    label={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? "*last name."
                                        : undefined
                                    }
                                    name={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? "lastName"
                                        : undefined
                                    }
                                    required={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? true
                                        : undefined
                                    }
                                    showHelperText={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? (() => {
                                            try {
                                              return $state.lastNameHelperShow;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return false;
                                              }
                                              throw e;
                                            }
                                          })()
                                        : false
                                    }
                                    status={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? "error"
                                        : "normal"
                                    }
                                  />

                                  {(
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepTwo"
                                    )
                                      ? true
                                      : hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                        ? true
                                        : false
                                  ) ? (
                                    <FormElement
                                      className={classNames(
                                        "__wab_instance",
                                        sty.formElement__zszGx,
                                        {
                                          [sty.formElementoutsideOnboarding_stepOne__zszGxUL7K]:
                                            hasVariant(
                                              $state,
                                              "outsideOnboarding",
                                              "stepOne"
                                            ),
                                          [sty.formElementoutsideOnboarding_stepTwo__zszGxm3MNz]:
                                            hasVariant(
                                              $state,
                                              "outsideOnboarding",
                                              "stepTwo"
                                            )
                                        }
                                      )}
                                      formInputComponent={
                                        <RadioGroup
                                          data-plasmic-name={"radioGroup"}
                                          data-plasmic-override={
                                            overrides.radioGroup
                                          }
                                          className={classNames(
                                            "__wab_instance",
                                            sty.radioGroup,
                                            {
                                              [sty.radioGroupoutsideOnboarding_stepOne]:
                                                hasVariant(
                                                  $state,
                                                  "outsideOnboarding",
                                                  "stepOne"
                                                )
                                            }
                                          )}
                                          radioOptionsSlot={
                                            <React.Fragment>
                                              <RadioOption
                                                className={classNames(
                                                  "__wab_instance",
                                                  sty.radioOption__jt7KZ,
                                                  {
                                                    [sty.radioOptionoutsideOnboarding_stepOne__jt7KZUL7K]:
                                                      hasVariant(
                                                        $state,
                                                        "outsideOnboarding",
                                                        "stepOne"
                                                      )
                                                  }
                                                )}
                                                disabled={false}
                                                status={"normal"}
                                                valueShown={"Yes."}
                                              >
                                                <RadioButtonSeparateComp
                                                  className={classNames(
                                                    "__wab_instance",
                                                    sty.radioButtonSeparateComp__gPqPs,
                                                    {
                                                      [sty.radioButtonSeparateCompoutsideOnboarding_stepOne__gPqPsUL7K]:
                                                        hasVariant(
                                                          $state,
                                                          "outsideOnboarding",
                                                          "stepOne"
                                                        )
                                                    }
                                                  )}
                                                  onClick={async () => {
                                                    const $steps = {};
                                                    $steps["runCode"] = true
                                                      ? (() => {
                                                          const actionArgs = {
                                                            customFunction:
                                                              async () => {
                                                                return (() => {
                                                                  if (
                                                                    $state.yesClickCount ===
                                                                    undefined
                                                                  ) {
                                                                    $state.yesClickCount = 0;
                                                                  }
                                                                  $state.yesClickCount =
                                                                    $state.yesClickCount +
                                                                    1;
                                                                  if (
                                                                    $state.yesClickCount %
                                                                      2 !==
                                                                    0
                                                                  ) {
                                                                    $state.isCheckedYes =
                                                                      "clicked";
                                                                    $state.isCheckedNo =
                                                                      "notclicked";
                                                                    $state.showTitleCredentials = true;
                                                                  } else {
                                                                    $state.isCheckedYes =
                                                                      "notclicked";
                                                                  }
                                                                  return console.log(
                                                                    "click count value:",
                                                                    $state.yesClickCount
                                                                  );
                                                                })();
                                                              }
                                                          };
                                                          return (({
                                                            customFunction
                                                          }) => {
                                                            return customFunction();
                                                          })?.apply(null, [
                                                            actionArgs
                                                          ]);
                                                        })()
                                                      : undefined;
                                                    if (
                                                      $steps["runCode"] !=
                                                        null &&
                                                      typeof $steps[
                                                        "runCode"
                                                      ] === "object" &&
                                                      typeof $steps["runCode"]
                                                        .then === "function"
                                                    ) {
                                                      $steps["runCode"] =
                                                        await $steps["runCode"];
                                                    }
                                                  }}
                                                  outsideOnboarding={"stepOne"}
                                                  status={(() => {
                                                    try {
                                                      return $state.isCheckedYes;
                                                    } catch (e) {
                                                      if (
                                                        e instanceof
                                                          TypeError ||
                                                        e?.plasmicType ===
                                                          "PlasmicUndefinedDataError"
                                                      ) {
                                                        return "notclicked";
                                                      }
                                                      throw e;
                                                    }
                                                  })()}
                                                />
                                              </RadioOption>
                                              <RadioOption
                                                className={classNames(
                                                  "__wab_instance",
                                                  sty.radioOption__qoFu2,
                                                  {
                                                    [sty.radioOptionoutsideOnboarding_stepOne__qoFu2UL7K]:
                                                      hasVariant(
                                                        $state,
                                                        "outsideOnboarding",
                                                        "stepOne"
                                                      )
                                                  }
                                                )}
                                                status={"normal"}
                                                valueShown={"No."}
                                              >
                                                <RadioButtonSeparateComp
                                                  className={classNames(
                                                    "__wab_instance",
                                                    sty.radioButtonSeparateComp__eoOMk,
                                                    {
                                                      [sty.radioButtonSeparateCompoutsideOnboarding_stepOne__eoOMkUL7K]:
                                                        hasVariant(
                                                          $state,
                                                          "outsideOnboarding",
                                                          "stepOne"
                                                        )
                                                    }
                                                  )}
                                                  onClick={async () => {
                                                    const $steps = {};
                                                    $steps["runCode"] = true
                                                      ? (() => {
                                                          const actionArgs = {
                                                            customFunction:
                                                              async () => {
                                                                return (() => {
                                                                  if (
                                                                    $state.noClickCount ===
                                                                    undefined
                                                                  ) {
                                                                    $state.noClickCount = 0;
                                                                  }
                                                                  $state.noClickCount =
                                                                    $state.noClickCount +
                                                                    1;
                                                                  if (
                                                                    $state.noClickCount %
                                                                      2 !==
                                                                    0
                                                                  ) {
                                                                    $state.isCheckedNo =
                                                                      "clicked";
                                                                    $state.isCheckedYes =
                                                                      "notclicked";
                                                                    $state.showTitleCredentials = false;
                                                                  } else if (
                                                                    $state.noClickCount %
                                                                      2 ===
                                                                    0
                                                                  ) {
                                                                    $state.isCheckedNo =
                                                                      "notclicked";
                                                                  }
                                                                  return console.log(
                                                                    "click count value:",
                                                                    $state.noClickCount
                                                                  );
                                                                })();
                                                              }
                                                          };
                                                          return (({
                                                            customFunction
                                                          }) => {
                                                            return customFunction();
                                                          })?.apply(null, [
                                                            actionArgs
                                                          ]);
                                                        })()
                                                      : undefined;
                                                    if (
                                                      $steps["runCode"] !=
                                                        null &&
                                                      typeof $steps[
                                                        "runCode"
                                                      ] === "object" &&
                                                      typeof $steps["runCode"]
                                                        .then === "function"
                                                    ) {
                                                      $steps["runCode"] =
                                                        await $steps["runCode"];
                                                    }
                                                  }}
                                                  outsideOnboarding={"stepOne"}
                                                  status={(() => {
                                                    try {
                                                      return $state.isCheckedNo;
                                                    } catch (e) {
                                                      if (
                                                        e instanceof
                                                          TypeError ||
                                                        e?.plasmicType ===
                                                          "PlasmicUndefinedDataError"
                                                      ) {
                                                        return "notclicked";
                                                      }
                                                      throw e;
                                                    }
                                                  })()}
                                                />
                                              </RadioOption>
                                            </React.Fragment>
                                          }
                                          type={"_default"}
                                        />
                                      }
                                      helperText={
                                        hasVariant(
                                          $state,
                                          "outsideOnboarding",
                                          "stepOne"
                                        )
                                          ? ``
                                          : undefined
                                      }
                                      label={
                                        hasVariant(
                                          $state,
                                          "outsideOnboarding",
                                          "stepOne"
                                        )
                                          ? "*are you a licensed clinician?"
                                          : undefined
                                      }
                                      name={
                                        hasVariant(
                                          $state,
                                          "outsideOnboarding",
                                          "stepOne"
                                        )
                                          ? "isUserLicensed"
                                          : undefined
                                      }
                                      required={
                                        hasVariant(
                                          $state,
                                          "outsideOnboarding",
                                          "stepOne"
                                        )
                                          ? true
                                          : undefined
                                      }
                                      showHelperText={
                                        hasVariant(
                                          $state,
                                          "outsideOnboarding",
                                          "stepOne"
                                        )
                                          ? false
                                          : false
                                      }
                                      status={"normal"}
                                    />
                                  ) : null}
                                  {(
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepTwo"
                                    )
                                      ? true
                                      : hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                        ? (() => {
                                            try {
                                              return $state.showTitleCredentials;
                                            } catch (e) {
                                              if (
                                                e instanceof TypeError ||
                                                e?.plasmicType ===
                                                  "PlasmicUndefinedDataError"
                                              ) {
                                                return true;
                                              }
                                              throw e;
                                            }
                                          })()
                                        : true
                                  ) ? (
                                    <div
                                      data-plasmic-name={
                                        "conditionalFieldsWrapper"
                                      }
                                      data-plasmic-override={
                                        overrides.conditionalFieldsWrapper
                                      }
                                      className={classNames(
                                        projectcss.all,
                                        sty.conditionalFieldsWrapper,
                                        {
                                          [sty.conditionalFieldsWrapperoutsideOnboarding_stepOne]:
                                            hasVariant(
                                              $state,
                                              "outsideOnboarding",
                                              "stepOne"
                                            ),
                                          [sty.conditionalFieldsWrapperoutsideOnboarding_stepTwo]:
                                            hasVariant(
                                              $state,
                                              "outsideOnboarding",
                                              "stepTwo"
                                            )
                                        }
                                      )}
                                    >
                                      <FormElement
                                        className={classNames(
                                          "__wab_instance",
                                          sty.formElement___2EJXh,
                                          {
                                            [sty.formElementoutsideOnboarding_stepOne___2EJXhUL7K]:
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                          }
                                        )}
                                        formInputComponent={
                                          <InputField
                                            className={classNames(
                                              "__wab_instance",
                                              sty.inputField__hYkEu,
                                              {
                                                [sty.inputFieldoutsideOnboarding_stepOne__hYkEuUL7K]:
                                                  hasVariant(
                                                    $state,
                                                    "outsideOnboarding",
                                                    "stepOne"
                                                  )
                                              }
                                            )}
                                            inputId={
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                                ? "titleId"
                                                : undefined
                                            }
                                            placeholder={
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                                ? '"Dr."'
                                                : "Dr."
                                            }
                                            status={
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                                ? "normal"
                                                : "normal"
                                            }
                                            type={
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                                ? "text"
                                                : undefined
                                            }
                                          />
                                        }
                                        helperText={"*optional."}
                                        label={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? "title."
                                            : "title"
                                        }
                                        name={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? "userTitle"
                                            : "title"
                                        }
                                        showHelperText={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? false
                                            : true
                                        }
                                        status={"normal"}
                                      />

                                      <FormElement
                                        className={classNames(
                                          "__wab_instance",
                                          sty.formElement__pqwqV,
                                          {
                                            [sty.formElementoutsideOnboarding_stepOne__pqwqVUL7K]:
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                          }
                                        )}
                                        formInputComponent={
                                          <InputField
                                            className={classNames(
                                              "__wab_instance",
                                              sty.inputField__ocCnN,
                                              {
                                                [sty.inputFieldoutsideOnboarding_stepOne__ocCnNUL7K]:
                                                  hasVariant(
                                                    $state,
                                                    "outsideOnboarding",
                                                    "stepOne"
                                                  )
                                              }
                                            )}
                                            inputId={
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                                ? "credentialsId"
                                                : undefined
                                            }
                                            placeholder={
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                                ? '"DDS", "DMD"'
                                                : "e.g. DDS DDM"
                                            }
                                            status={
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                                ? "normal"
                                                : "normal"
                                            }
                                            type={
                                              hasVariant(
                                                $state,
                                                "outsideOnboarding",
                                                "stepOne"
                                              )
                                                ? "text"
                                                : undefined
                                            }
                                          />
                                        }
                                        helperText={"*optional."}
                                        label={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? "credentials."
                                            : "credentials"
                                        }
                                        name={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? "userCredentials"
                                            : "credentials"
                                        }
                                        required={false}
                                        showHelperText={
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                            ? false
                                            : true
                                        }
                                        status={"normal"}
                                      />
                                    </div>
                                  ) : null}
                                </React.Fragment>
                              }
                              layout={"_default"}
                            />
                          </React.Fragment>
                        }
                        infotextWrapper2={
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text___6RMkN,
                              {
                                [sty.textoutsideOnboarding_stepOne___6RMkNUL7K]:
                                  hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepOne"
                                  )
                              }
                            )}
                          >
                            {hasVariant(
                              $state,
                              "outsideOnboarding",
                              "stepOne"
                            ) ? (
                              <React.Fragment>
                                <React.Fragment>
                                  {"Already have an account? "}
                                </React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "var(--token-jyNQAasUGv4X)" }}
                                >
                                  {"[ "}
                                </span>
                                <React.Fragment>{""}</React.Fragment>
                                {
                                  <PlasmicLink__
                                    data-plasmic-name={"link"}
                                    data-plasmic-override={overrides.link}
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.a,
                                      projectcss.__wab_text,
                                      projectcss.plasmic_default__inline,
                                      sty.link,
                                      {
                                        [sty.linkoutsideOnboarding_stepOne]:
                                          hasVariant(
                                            $state,
                                            "outsideOnboarding",
                                            "stepOne"
                                          )
                                      }
                                    )}
                                    href={
                                      hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepOne"
                                      )
                                        ? `/login`
                                        : "https://opformypractice.com/"
                                    }
                                    platform={"react"}
                                  >
                                    <React.Fragment>
                                      <span
                                        className={
                                          "plasmic_default__all plasmic_default__span"
                                        }
                                        style={{
                                          color: "var(--token-jyNQAasUGv4X)"
                                        }}
                                      >
                                        {"log in"}
                                      </span>
                                    </React.Fragment>
                                  </PlasmicLink__>
                                }
                                <React.Fragment>{""}</React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "var(--token-jyNQAasUGv4X)" }}
                                >
                                  {" ]"}
                                </span>
                              </React.Fragment>
                            ) : (
                              "Helper text."
                            )}
                          </div>
                        }
                        onContainerChange={async (...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "onboardingContainer",
                            "container"
                          ]).apply(null, eventArgs);
                          if (
                            eventArgs.length > 1 &&
                            eventArgs[1] &&
                            eventArgs[1]._plasmic_state_init_
                          ) {
                            return;
                          }
                        }}
                        onShowTermsChange={async (...eventArgs) => {
                          generateStateOnChangeProp($state, [
                            "onboardingContainer",
                            "showTerms"
                          ]).apply(null, eventArgs);
                          if (
                            eventArgs.length > 1 &&
                            eventArgs[1] &&
                            eventArgs[1]._plasmic_state_init_
                          ) {
                            return;
                          }
                        }}
                        showHelperText={
                          hasVariant($state, "outsideOnboarding", "stepTwo")
                            ? false
                            : hasVariant($state, "outsideOnboarding", "stepOne")
                              ? true
                              : undefined
                        }
                        showTerms={generateStateValueProp($state, [
                          "onboardingContainer",
                          "showTerms"
                        ])}
                        stepHeader={
                          <div
                            className={classNames(
                              projectcss.all,
                              projectcss.__wab_text,
                              sty.text__rioO,
                              {
                                [sty.textoutsideOnboarding_stepThree__rioOrZxv]:
                                  hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepThree"
                                  ),
                                [sty.textoutsideOnboarding_stepTwo__rioOm3MNz]:
                                  hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepTwo"
                                  )
                              }
                            )}
                          >
                            {hasVariant(
                              $state,
                              "outsideOnboarding",
                              "stepThree"
                            )
                              ? "check your inbox."
                              : hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepTwo"
                                  )
                                ? "add your email."
                                : "let's start with your name."}
                          </div>
                        }
                        text={
                          <React.Fragment>
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__o4SGw,
                                {
                                  [sty.textoutsideOnboarding_stepThree__o4SGwrZxv]:
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepThree"
                                    )
                                }
                              )}
                            >
                              <React.Fragment>
                                <React.Fragment>
                                  {"We\u2019ve sent a message with a link to "}
                                </React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "#000000", fontWeight: 600 }}
                                >
                                  {"john@email.com"}
                                </span>
                                <React.Fragment>
                                  {" to verify your email."}
                                </React.Fragment>
                              </React.Fragment>
                            </div>
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__bpmP,
                                {
                                  [sty.textoutsideOnboarding_stepThree__bpmPrZxv]:
                                    hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepThree"
                                    )
                                }
                              )}
                            >
                              {
                                "This link expires in 24 hours.\nDidn't receive an email? Check your spam folder."
                              }
                            </div>
                          </React.Fragment>
                        }
                        text2={
                          <React.Fragment>
                            {false ? (
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text__gYAv
                                )}
                              >
                                {"create your OP account."}
                              </div>
                            ) : null}
                            {false ? (
                              <div
                                className={classNames(
                                  projectcss.all,
                                  projectcss.__wab_text,
                                  sty.text__d9Akl
                                )}
                              >
                                {
                                  "You\u2019re in the process of creating your OP account. Your account isn\u2019t complete. There are a few more steps to go."
                                }
                              </div>
                            ) : null}
                          </React.Fragment>
                        }
                      />
                    }
                  />

                  <SignupProgressBar
                    data-plasmic-name={"signupProgressBar"}
                    data-plasmic-override={overrides.signupProgressBar}
                    className={classNames(
                      "__wab_instance",
                      sty.signupProgressBar
                    )}
                    stepsMap2={
                      <React.Fragment>
                        <StepProgressBar
                          className={classNames(
                            "__wab_instance",
                            sty.stepProgressBar__hyujd,
                            {
                              [sty.stepProgressBaroutsideOnboarding_stepOne__hyujdUL7K]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepOne"
                                ),
                              [sty.stepProgressBaroutsideOnboarding_stepThree__hyujDrZxv]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepThree"
                                ),
                              [sty.stepProgressBaroutsideOnboarding_stepTwo__hyujdm3MNz]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepTwo"
                                )
                            }
                          )}
                          statusType={
                            hasVariant($state, "outsideOnboarding", "stepThree")
                              ? "completed"
                              : hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepTwo"
                                  )
                                ? "completed"
                                : hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                  ? "currentStep"
                                  : "notCompleted"
                          }
                        />

                        <StepProgressBar
                          className={classNames(
                            "__wab_instance",
                            sty.stepProgressBar__bcmgw,
                            {
                              [sty.stepProgressBaroutsideOnboarding_stepOne__bcmgwUL7K]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepOne"
                                ),
                              [sty.stepProgressBaroutsideOnboarding_stepThree__bcmgwrZxv]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepThree"
                                ),
                              [sty.stepProgressBaroutsideOnboarding_stepTwo__bcmgwM3MNz]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepTwo"
                                )
                            }
                          )}
                          statusType={
                            hasVariant($state, "outsideOnboarding", "stepThree")
                              ? "completed"
                              : hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepTwo"
                                  )
                                ? "currentStep"
                                : hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                  ? "notCompleted"
                                  : undefined
                          }
                        />

                        <StepProgressBar
                          className={classNames(
                            "__wab_instance",
                            sty.stepProgressBar__jf0T2,
                            {
                              [sty.stepProgressBaroutsideOnboarding_stepOne__jf0T2UL7K]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepOne"
                                ),
                              [sty.stepProgressBaroutsideOnboarding_stepThree__jf0T2RZxv]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepThree"
                                ),
                              [sty.stepProgressBaroutsideOnboarding_stepTwo__jf0T2M3MNz]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepTwo"
                                )
                            }
                          )}
                          statusType={
                            hasVariant($state, "outsideOnboarding", "stepThree")
                              ? "currentStep"
                              : hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepTwo"
                                  )
                                ? "notCompleted"
                                : hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                  ? "notCompleted"
                                  : undefined
                          }
                        />

                        <StepProgressBar
                          className={classNames(
                            "__wab_instance",
                            sty.stepProgressBar__a05R,
                            {
                              [sty.stepProgressBaroutsideOnboarding_stepOne__a05RUL7K]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepOne"
                                ),
                              [sty.stepProgressBaroutsideOnboarding_stepThree__a05RrZxv]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepThree"
                                ),
                              [sty.stepProgressBaroutsideOnboarding_stepTwo__a05RM3MNz]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepTwo"
                                )
                            }
                          )}
                          statusType={
                            hasVariant($state, "outsideOnboarding", "stepThree")
                              ? "notCompleted"
                              : hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepTwo"
                                  )
                                ? "notCompleted"
                                : hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                  ? "notCompleted"
                                  : undefined
                          }
                        />

                        <StepProgressBar
                          className={classNames(
                            "__wab_instance",
                            sty.stepProgressBar__aeHww,
                            {
                              [sty.stepProgressBaroutsideOnboarding_stepOne__aeHwwUL7K]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepOne"
                                ),
                              [sty.stepProgressBaroutsideOnboarding_stepThree__aeHwwrZxv]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepThree"
                                ),
                              [sty.stepProgressBaroutsideOnboarding_stepTwo__aeHwwM3MNz]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepTwo"
                                )
                            }
                          )}
                          statusType={
                            hasVariant($state, "outsideOnboarding", "stepThree")
                              ? "notCompleted"
                              : hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepTwo"
                                  )
                                ? "notCompleted"
                                : hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                  ? "notCompleted"
                                  : undefined
                          }
                        />
                      </React.Fragment>
                    }
                  />
                </React.Fragment>
              }
              tabNav={
                <BottomNav
                  data-plasmic-name={"bottomNav"}
                  data-plasmic-override={overrides.bottomNav}
                  className={classNames("__wab_instance", sty.bottomNav, {
                    [sty.bottomNavoutsideOnboarding_stepOne]: hasVariant(
                      $state,
                      "outsideOnboarding",
                      "stepOne"
                    ),
                    [sty.bottomNavoutsideOnboarding_stepThree]: hasVariant(
                      $state,
                      "outsideOnboarding",
                      "stepThree"
                    ),
                    [sty.bottomNavoutsideOnboarding_stepTwo]: hasVariant(
                      $state,
                      "outsideOnboarding",
                      "stepTwo"
                    )
                  })}
                  nameWrapper={
                    <LeftSectionNav
                      data-plasmic-name={"leftSectionNav"}
                      data-plasmic-override={overrides.leftSectionNav}
                      bottomNav={"defaultOnboarding"}
                      className={classNames(
                        "__wab_instance",
                        sty.leftSectionNav,
                        {
                          [sty.leftSectionNavoutsideOnboarding_stepOne]:
                            hasVariant($state, "outsideOnboarding", "stepOne"),
                          [sty.leftSectionNavoutsideOnboarding_stepThree]:
                            hasVariant(
                              $state,
                              "outsideOnboarding",
                              "stepThree"
                            ),
                          [sty.leftSectionNavoutsideOnboarding_stepTwo]:
                            hasVariant($state, "outsideOnboarding", "stepTwo")
                        }
                      )}
                      currentPageTitle={"enter some text"}
                      topNav={"tabTitle"}
                    >
                      {hasVariant($state, "outsideOnboarding", "stepThree")
                        ? "create your OP account."
                        : hasVariant($state, "outsideOnboarding", "stepTwo")
                          ? "create your OP account."
                          : hasVariant($state, "outsideOnboarding", "stepOne")
                            ? "create your OP account."
                            : "Enter some text"}
                    </LeftSectionNav>
                  }
                  navModule={
                    <ModuleNav
                      data-plasmic-name={"moduleNav"}
                      data-plasmic-override={overrides.moduleNav}
                      byPlacement={"navOnboarding"}
                      className={classNames("__wab_instance", sty.moduleNav, {
                        [sty.moduleNavoutsideOnboarding_stepOne]: hasVariant(
                          $state,
                          "outsideOnboarding",
                          "stepOne"
                        ),
                        [sty.moduleNavoutsideOnboarding_stepThree]: hasVariant(
                          $state,
                          "outsideOnboarding",
                          "stepThree"
                        ),
                        [sty.moduleNavoutsideOnboarding_stepTwo]: hasVariant(
                          $state,
                          "outsideOnboarding",
                          "stepTwo"
                        )
                      })}
                      navButtonSlot={
                        <ButtonNav
                          data-plasmic-name={"buttonNav"}
                          data-plasmic-override={overrides.buttonNav}
                          className={classNames(
                            "__wab_instance",
                            sty.buttonNav,
                            {
                              [sty.buttonNavoutsideOnboarding_stepOne]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepOne"
                                ),
                              [sty.buttonNavoutsideOnboarding_stepThree]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepThree"
                                ),
                              [sty.buttonNavoutsideOnboarding_stepTwo]:
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepTwo"
                                )
                            }
                          )}
                          color={
                            hasVariant($state, "outsideOnboarding", "stepThree")
                              ? "greyTwo"
                              : hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepOne"
                                  )
                                ? "greyTwo"
                                : undefined
                          }
                          disabled={
                            hasVariant($state, "outsideOnboarding", "stepTwo")
                              ? true
                              : hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepOne"
                                  )
                                ? false
                                : undefined
                          }
                          iconForButton={
                            <PlasmicImg__
                              data-plasmic-name={"img"}
                              data-plasmic-override={overrides.img}
                              alt={""}
                              className={classNames(sty.img, {
                                [sty.imgoutsideOnboarding_stepOne]: hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepOne"
                                ),
                                [sty.imgoutsideOnboarding_stepThree]:
                                  hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepThree"
                                  ),
                                [sty.imgoutsideOnboarding_stepTwo]: hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepTwo"
                                )
                              })}
                              displayHeight={"100%"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"none"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"100%"}
                              loading={"lazy"}
                              src={
                                hasVariant(
                                  $state,
                                  "outsideOnboarding",
                                  "stepThree"
                                )
                                  ? {
                                      src: image183TIq2GJx3VUp,
                                      fullWidth: 20,
                                      fullHeight: 20,
                                      aspectRatio: undefined
                                    }
                                  : hasVariant(
                                        $state,
                                        "outsideOnboarding",
                                        "stepTwo"
                                      )
                                    ? {
                                        src: image183TIq2GJx3VUp,
                                        fullWidth: 20,
                                        fullHeight: 20,
                                        aspectRatio: undefined
                                      }
                                    : hasVariant(
                                          $state,
                                          "outsideOnboarding",
                                          "stepOne"
                                        )
                                      ? {
                                          src: image183TIq2GJx3VUp,
                                          fullWidth: 20,
                                          fullHeight: 20,
                                          aspectRatio: undefined
                                        }
                                      : {
                                          src: image9YxLRnjN8Oa4,
                                          fullWidth: 20,
                                          fullHeight: 20,
                                          aspectRatio: undefined
                                        }
                              }
                            />
                          }
                          onClick={async () => {
                            const $steps = {};
                            $steps["goToWebHome"] = true
                              ? (() => {
                                  const actionArgs = { destination: `/home` };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      location.assign(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToWebHome"] != null &&
                              typeof $steps["goToWebHome"] === "object" &&
                              typeof $steps["goToWebHome"].then === "function"
                            ) {
                              $steps["goToWebHome"] =
                                await $steps["goToWebHome"];
                            }
                          }}
                          shape={
                            hasVariant($state, "outsideOnboarding", "stepThree")
                              ? "globalRounding"
                              : hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepTwo"
                                  )
                                ? "globalRounding"
                                : hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                  ? "globalRounding"
                                  : undefined
                          }
                          status={
                            hasVariant($state, "outsideOnboarding", "stepThree")
                              ? "normal"
                              : hasVariant(
                                    $state,
                                    "outsideOnboarding",
                                    "stepTwo"
                                  )
                                ? "disabled"
                                : hasVariant(
                                      $state,
                                      "outsideOnboarding",
                                      "stepOne"
                                    )
                                  ? "normal"
                                  : undefined
                          }
                        />
                      }
                    />
                  }
                  type={
                    hasVariant($state, "outsideOnboarding", "stepThree")
                      ? "withRightModule"
                      : hasVariant($state, "outsideOnboarding", "stepTwo")
                        ? "withRightModule"
                        : hasVariant($state, "outsideOnboarding", "stepOne")
                          ? "withRightModule"
                          : undefined
                  }
                />
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageOnboarding: [
    "pageOnboarding",
    "appShell",
    "tabLayout",
    "bottomNav",
    "moduleNav",
    "buttonNav",
    "img",
    "leftSectionNav",
    "pageLayout",
    "onboardingContainer",
    "formStepTwo",
    "formStepOne",
    "radioGroup",
    "conditionalFieldsWrapper",
    "link",
    "signupProgressBar"
  ],

  appShell: [
    "appShell",
    "tabLayout",
    "bottomNav",
    "moduleNav",
    "buttonNav",
    "img",
    "leftSectionNav",
    "pageLayout",
    "onboardingContainer",
    "formStepTwo",
    "formStepOne",
    "radioGroup",
    "conditionalFieldsWrapper",
    "link",
    "signupProgressBar"
  ],

  tabLayout: [
    "tabLayout",
    "bottomNav",
    "moduleNav",
    "buttonNav",
    "img",
    "leftSectionNav",
    "pageLayout",
    "onboardingContainer",
    "formStepTwo",
    "formStepOne",
    "radioGroup",
    "conditionalFieldsWrapper",
    "link",
    "signupProgressBar"
  ],

  bottomNav: ["bottomNav", "moduleNav", "buttonNav", "img", "leftSectionNav"],
  moduleNav: ["moduleNav", "buttonNav", "img"],
  buttonNav: ["buttonNav", "img"],
  img: ["img"],
  leftSectionNav: ["leftSectionNav"],
  pageLayout: [
    "pageLayout",
    "onboardingContainer",
    "formStepTwo",
    "formStepOne",
    "radioGroup",
    "conditionalFieldsWrapper",
    "link"
  ],

  onboardingContainer: [
    "onboardingContainer",
    "formStepTwo",
    "formStepOne",
    "radioGroup",
    "conditionalFieldsWrapper",
    "link"
  ],

  formStepTwo: ["formStepTwo"],
  formStepOne: ["formStepOne", "radioGroup", "conditionalFieldsWrapper"],
  radioGroup: ["radioGroup"],
  conditionalFieldsWrapper: ["conditionalFieldsWrapper"],
  link: ["link"],
  signupProgressBar: ["signupProgressBar"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebSignup__ArgProps,
          internalVariantPropNames: PlasmicWebSignup__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebSignup__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageOnboarding") {
    func.displayName = "PlasmicWebSignup";
  } else {
    func.displayName = `PlasmicWebSignup.${nodeName}`;
  }
  return func;
}

export const PlasmicWebSignup = Object.assign(
  // Top-level PlasmicWebSignup renders the root element
  makeNodeComponent("pageOnboarding"),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    tabLayout: makeNodeComponent("tabLayout"),
    bottomNav: makeNodeComponent("bottomNav"),
    moduleNav: makeNodeComponent("moduleNav"),
    buttonNav: makeNodeComponent("buttonNav"),
    img: makeNodeComponent("img"),
    leftSectionNav: makeNodeComponent("leftSectionNav"),
    pageLayout: makeNodeComponent("pageLayout"),
    onboardingContainer: makeNodeComponent("onboardingContainer"),
    formStepTwo: makeNodeComponent("formStepTwo"),
    formStepOne: makeNodeComponent("formStepOne"),
    radioGroup: makeNodeComponent("radioGroup"),
    conditionalFieldsWrapper: makeNodeComponent("conditionalFieldsWrapper"),
    link: makeNodeComponent("link"),
    signupProgressBar: makeNodeComponent("signupProgressBar"),
    // Metadata about props expected for PlasmicWebSignup
    internalVariantProps: PlasmicWebSignup__VariantProps,
    internalArgProps: PlasmicWebSignup__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "OP | signup.",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicWebSignup;
/* prettier-ignore-end */
